import React from 'react';
import { Screen } from '../enums/screen.enum';
import { useTranslation } from 'react-i18next';
import ContentContainer from '../partials/ContentContainer';
import ScreenContainer from '../partials/ScreenContainer';
import { Button, ButtonGroup, ButtonVariant } from '../components/Button';
import ActionsContainer from '../partials/ActionsContainer';

export default function CGUScreen({
  isActive,
  setScreen,
}: {
  isActive: boolean;
  setScreen: (screen: Screen) => void;
}) {
  const { t } = useTranslation();

  return !isActive ? (
    <></>
  ) : (
    <ScreenContainer title={t('screens.cgu.title')}>
      <ContentContainer>
        <div
          dangerouslySetInnerHTML={{
            __html: t('data:cgu'),
          }}
        ></div>
      </ContentContainer>

      <ActionsContainer>
        <ButtonGroup>
          <Button
            variant={ButtonVariant.Green}
            onClick={() => setScreen(Screen.checkboxes)}
          >
            {t('common.back')}
          </Button>
        </ButtonGroup>
      </ActionsContainer>
    </ScreenContainer>
  );
}
